import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposizione-esecuzione-view',
  templateUrl: './form-opposizione-esecuzione-view.component.html',
  styleUrls: ['./form-opposizione-esecuzione-view.component.css']
})
export class FormOpposizioneEsecuzioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
